import { forwardRef } from "react";
import { Checkbox, ListItemText, MenuItem, Select, type SelectChangeEvent } from "~/common/mui";
import classes from "./SPFinderFilters.module.less";
import type { Option } from "~/features/salesPartner/components/SearchCard/SalesPartnerSearchBox";
import { useTranslation } from "react-i18next";

export interface SPFinderFiltersRef {
  reset: () => void;
}

interface SPFinderFiltersProps {
  productCompetencesOptions?: Option[];
  certifiedCompetencesOptions?: Option[];
  selectedProductKeys: string[];
  selectedServiceKeys: string[];
  handleProductChange: SelectHandler;
  handleServiceChange: SelectHandler;
  getLabelByKey: GetLabelByKeyFn;
}

type SelectHandler = (event: SelectChangeEvent<string[]>) => void;

type GetLabelByKeyFn = (key: string, options: Option[]) => string;

const SPFinderFilters = forwardRef<SPFinderFiltersRef, SPFinderFiltersProps>((props, ref) => {
  const { t } = useTranslation();

  const {
    productCompetencesOptions = [],
    certifiedCompetencesOptions = [],
    selectedProductKeys,
    selectedServiceKeys,
    handleProductChange,
    handleServiceChange,
    getLabelByKey,
  } = props;

  return (
    <div className={classes.extraFilters}>
      <div className={classes.extraFilter}>
        <p>{t("partnerFinder.search.productFilter")}</p>
        <Select
          size="small"
          multiple
          displayEmpty
          value={selectedProductKeys}
          onChange={handleProductChange}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return t("partnerFinder.search.productFilterPlaceholder");
            }
            return selected.map((key) => getLabelByKey(key, productCompetencesOptions)).join(", ");
          }}
          className={classes.filter}
        >
          {productCompetencesOptions.map(({ key, label }) => (
            <MenuItem key={key} value={key}>
              <Checkbox checked={selectedProductKeys.includes(key)} edge="start" />
              <ListItemText primary={label} />
            </MenuItem>
          ))}
        </Select>
      </div>
      <div className={classes.extraFilter}>
        <p>{t("partnerFinder.search.serviceFilter")}</p>
        <Select
          size="small"
          multiple
          displayEmpty
          value={selectedServiceKeys}
          onChange={handleServiceChange}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return t("partnerFinder.search.serviceFilterPlaceholder");
            }
            return selected.map((key) => getLabelByKey(key, certifiedCompetencesOptions)).join(", ");
          }}
          className={classes.filter}
          // MenuProps={sharedMenuProps}
        >
          {certifiedCompetencesOptions.map(({ key, label }) => (
            <MenuItem key={key} value={key}>
              <Checkbox checked={selectedServiceKeys.includes(key)} edge="start" />
              <ListItemText primary={label} />
            </MenuItem>
          ))}
        </Select>
      </div>
    </div>
  );
});

export default SPFinderFilters;
